module.exports = __webpack_public_path__ + "img/bagged-cargo.7e46fe2.svg";